import React, { useContext, useEffect, useState } from 'react';
import 'rc-slider/assets/index.css';
import {
  CartProvider,
  Image,
  Link,
  useCart
} from '@shopify/hydrogen';
import { useAppDispatch, useAppSelector, useAppStore } from '../../lib/hooks';
import { executeSearch, fullResponseSearch, loadMemory, responseSearch, preloadFilters } from '../../store/slices/search';
import { getParamsUrl, trackSpeed, valueByEnviroment, roundDownToNearestTen, getPathUrl, hasUrlSection, getParamUrl } from '../../lib/Utils';
import BookNotFoundImage from '../../assets/image/default-book-image-not-found.png';
import SpinnerIcon from '../SpinnerIcon.client';
import { sendEvent } from '../../lib/analitycs';
import { SearchContext } from '../context/Search.client';
import { useCartUI } from '../CartUIProvider.client';
import { getSanityData } from '../../lib/fetchServiceApi';
import {GLOBAL_VARS} from '../../lib/globalvars';

const pageConfiguration = {
  isStarted: false,
  appendMore: true,
  currentPage: 1,
  isEnableT: true,
  productList: [], 
  directionUp: false,
  lastTop: 0, 
  limit: 32,
  currentPage:1,
  memoryLoaded:false,
  searchText:'',
};

const attributes = {
  progressReported: 0
}

export default function Products({}) {
  const dispatch = useAppDispatch();
  const searchId = useAppSelector((state) => state.search).searchId;
  const origin = useAppSelector((state) => state.search).origin;
  const filters = useAppSelector((state) => state.search).filters;
  const order = useAppSelector((state) => state.search).order;
  const fullResponse = useAppSelector((state) => state.search).fullResponse;
  const filterOnPress = useAppSelector((state) => state.search).filterOnPress;
  const [showResultList, setShowResultList] = useState(true);
  const store = useAppStore();
  const [productList, setProductList] = useState([]);
  const [textUserSearch, setTextUser] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const { parentSection, category } = useContext(SearchContext);
  const {isCartOpen, openCart} = useCartUI();
  const [currentAdd, setCurrentAdd] = useState(false);

  useEffect(()=>{
    setTextUser(getParamsUrl('q'));
  }, []);

  useEffect(()=>{
    if(searchId || category){
      if(origin !== 'scrollAppendPage'){
        
        let memory = getMemory();
        if(getParamsUrl('q') && getParamsUrl('q') !== memory?.searchText){
          localStorage.setItem('main-filters', '')
        }

        if(!getParamsUrl('origin')){
          clearMemory();
        }
        
        pageConfiguration.currentPage = 1;
        pageConfiguration.productList = [];
                
        setProductList([]); 
      }
      
      fetchProducts();
    }
  }, [searchId, category]);
  
  useEffect(()=>{
    let memory = getMemory();
    let windowWeigth = window.innerWidth;

    if(windowWeigth > 0 && windowWeigth < 768){
      pageConfiguration.limit = 25;
    }else if (windowWeigth > 768 && windowWeigth <= 1024){
      pageConfiguration.limit = 18;
    }else if (windowWeigth > 1024 && windowWeigth <= 1440){
      pageConfiguration.limit = 24;
    }else if (windowWeigth > 1440 && windowWeigth <= 1600){
      pageConfiguration.limit = 32;
    }else if (windowWeigth > 1600 && windowWeigth <= 2000){
      pageConfiguration.limit = 24;
    }else if (windowWeigth > 2000 && windowWeigth <= 9999){
      pageConfiguration.limit = 28;
    }else{
      pageConfiguration.limit = 10;
    }

    const presetData = (memory)=>{
      pageConfiguration.currentPage = memory.pageConfiguration.currentPage;
      pageConfiguration.productList = memory.pageConfiguration.productList;
      pageConfiguration.lastTop = memory.pageConfiguration.lastTop;
      pageConfiguration.isEnableT = false;
      pageConfiguration.searchText = memory.searchText;
    }

    if(getParamsUrl('origin') === 'product'){
      pageConfiguration.memoryLoaded = true;
      let data = getMemory()?.fullResponse;
      setProductList(memory.pageConfiguration.productList);
      dispatch(fullResponseSearch(data));
      dispatchCatalog(data.catalogs);
      dispatch(loadMemory(memory));

      presetData(memory);

      setTimeout(()=>{
        window.scrollTo(0, getMemory().pageConfiguration.lastTop);
      }, 1000)
    }else if(getParamsUrl('q')){
      dispatch(executeSearch());
    }else{
      clearFilters();
    }

    const handleScroll = ()=>{
      let scrollTop = window.scrollY;
      let scrollHeight = document.documentElement.scrollHeight;
      let callNewPages = (scrollHeight * 30) / 100;
      let heigthLimit = scrollHeight - ((scrollHeight * 20) / 100);

      if(
          scrollTop > callNewPages
          && pageConfiguration.isEnableT 
          && !pageConfiguration.directionUp
          && scrollTop < heigthLimit
          && pageConfiguration.appendMore
      ){
          pageConfiguration.isEnableT = false;
          
          dispatch(executeSearch('scrollAppendPage'));
      }

      let percentScroll = ( scrollTop / scrollHeight) * 100;

      const sendEventScroll = (percentage)=>{
        sendEvent('ux_scroll',{
          percentage: percentage
        });
      }

      if(percentScroll > attributes.progressReported){
        if(attributes.progressReported == 0 && percentScroll > 25 && percentScroll < 50){
          attributes.progressReported = 25;
          sendEventScroll(attributes.progressReported);
        }else if(attributes.progressReported == 25 && percentScroll > 50 && percentScroll < 75){
          attributes.progressReported = 50;
          sendEventScroll(attributes.progressReported);
        }else if(attributes.progressReported == 50 && percentScroll > 75 && percentScroll < 90){
          attributes.progressReported = 75;
          sendEventScroll(attributes.progressReported);
        }else if(attributes.progressReported == 75 && percentScroll > 90){
          attributes.progressReported = 100;
          sendEventScroll(attributes.progressReported);
        }
      }

      pageConfiguration.directionUp = (pageConfiguration.lastTop < scrollTop) ? false : true;
      pageConfiguration.lastTop = scrollTop;
    };
    
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  },[])

  useEffect(()=>{
    if(filterOnPress === 'CHANGE_UP' || filterOnPress === 'CHANGE_DOWN'){
      const element = document.getElementById('list-name-category') ?? document.getElementById('list-name-search');
          
      if(element){
        const topPosition = (element.getBoundingClientRect().top + window.scrollY) - 200;
        document.documentElement.scrollTo({ top: topPosition, behavior: 'smooth' });
      }
    }
  }, [filterOnPress])

  const clearMemory = ()=>{
    localStorage.setItem('search-selections','');
  }

  const getMemory = ()=>{
    let memory = localStorage.getItem('search-selections');
    memory = memory ? JSON.parse(memory) : null;
    return memory;
  }

  const clearFilters = ()=>{
    localStorage.setItem('main-filters','');
  }

  const getFiltersByUrl = ()=>{
    let sections = [
      ['category', getParamUrl('category')],
      ['age_group', getParamUrl('age_group')],
      ['price', getParamUrl('price')],
      ['author', getParamUrl('author')],
      ['format', getParamUrl('format')],
      ['language', getParamUrl('language')],
      ['tag', getParamUrl('tag')],
    ];

    return sections.filter((section)=>{return section[1] !== null});
  }

  const dispatchCatalog = (catalogs)=>{
    let allFilters = localStorage.getItem('main-filters');

    if(allFilters){
      catalogs = JSON.parse(allFilters);
    }
    
    dispatch(responseSearch(catalogs));

    let filtersUrl = getFiltersByUrl();
    if(!pageConfiguration.isStarted && filtersUrl.length > 0){
      setShowResultList(false);
      dispatch(preloadFilters(filtersUrl));
      setTimeout(()=>{
        dispatch(executeSearch());
        setShowResultList(true);
      }, 1000);
    }
  }

  const fetchProducts = ()=>{
    // valueByEnviroment('-dev','')
    const url = 'https://search'+ valueByEnviroment('','') +'.ellibrero.com/search';
    let memory = getMemory();
    let q = '';

    let searchText = getParamsUrl('q') ? getParamsUrl('q') : memory?.searchText;
    setIsLoading(true);

    const appedCriteria = (key, value)=>{
      q += (!q) ? '?' : '&';
      q += key + '=' + value;
    }

    if(parentSection === 'ofertas'){
      appedCriteria('f_sale', '1');
    }else if (window.location.pathname.includes('/categoria-producto/novedades')) {
      appedCriteria('f_newrelease', '1');
      appedCriteria('f_product_type', 'Books');
    }else if(category){
      let paramsUrl = getPathUrl().split('/');
      let section = paramsUrl[1];
      let keyTag = (section === 'categoria-producto') ? 'f_catslug' : 'f_tagslug';
      
      appedCriteria(keyTag, paramsUrl[ (paramsUrl.length - 1) ]);
    }else{
      appedCriteria('q', searchText+'*');
    }

    if(Object.keys(filters).length > 0)
    for(let filter of Object.keys(filters)){
      let values = filters[filter];

      if(filter === 'categories'){filter='category';}
      if(filter === 'age_group'){filter='age';}
      if(filter === 'tags'){filter='tag';}
      
      for(let value of values){
        appedCriteria('f_'+filter+'', encodeURIComponent(value));
      }
    }

    let offset = ((pageConfiguration.currentPage - 1) * pageConfiguration.limit);
    appedCriteria('offset', offset);
    appedCriteria('limit', pageConfiguration.limit);
    
    if(order){
      let orderSplit = order.split('=');
      appedCriteria(orderSplit[0], orderSplit[1]);
    }else if(hasUrlSection('/search')){
      appedCriteria('o_relevance', 'desc');
    }else{
      appedCriteria('o_date', 'desc');
    }

    appedCriteria('o_ebook', 'asc');

    const trackEvents = (data)=>{
      if(pageConfiguration.currentPage == 1){
        sendEvent('view_'+parentSection+'_results',{
          search_results: data.totalMatches,
          search_term: decodeURIComponent(searchText)
        });
        sendEvent('ux_scroll',{
          percentage: 0,
        });
      }

      // List items
      let params = {
        item_list_id: pageConfiguration.currentPage,
        item_list_name:'search',
        ecommerce: {
          items: []
        }
      };

      let indexValue = 0;
      for(let info of data.result){
        params.ecommerce.items.push({
          item_id: info.isbn,
          item_name: info.title,
          affiliation: info.affiliation,
          coupon: '',
          currency: info.currency,
          creative_name: '',
          creative_slot: '',
          discount: Math.abs(info.discount),
          index: indexValue,
          item_brand: info.brand,//
          item_category: info.category,
          item_category2: '',
          item_category3: '',
          item_category4: '',
          item_category5: '',
          item_list_id: pageConfiguration.currentPage,
          item_list_name: 'search',
          item_variant: '',
          location_id: '',
          price: info.price,
          promotion_id: '',
          promotion_name: '',
          quantity: '1'
        })
        
        indexValue++;
      }

      if(parentSection === 'search'){
        sendEvent('view_item_list', params);
      }else{
        sendEvent('view_item_list_'+parentSection, params);
      }
      
    }

    trackSpeed('start');

    fetch(url + q, {
      method: 'GET',
      cache: "no-store"
    })
    .then(response => response.json())
    .then((data)=>{

      // if(data?.error){
      //   location.reload();
      // }

      if(data.result === null){
        setIsLoading(false);
      }

      trackSpeed('end', {name:'search', searchText:searchText});

      if(data.result === null){
        setIsLoading(false);
      }

      if(data.result && data.result.length > 0){
        setIsLoading(false);
        trackEvents(data, searchText);
        for(let book of data.result){
          pageConfiguration.productList.push(book);
        }

        const uniqueProducts = [...new Map(pageConfiguration.productList.map(p => [p.id, p])).values()];
        setProductList(uniqueProducts);

        if(!pageConfiguration.isStarted){
          dispatch(fullResponseSearch(data));
          dispatchCatalog(data.catalogs);
        }

        // Setting filters are provided initially, which means for the parent. 
        // Usually, when any filter is chosen, the API will return a different catalog of filters.
        if(!localStorage.getItem('main-filters')){
          localStorage.setItem('main-filters', JSON.stringify(data.catalogs))
        }

        pageConfiguration.currentPage++;
        pageConfiguration.appendMore = true;
      }else{

        pageConfiguration.appendMore = false;
      }

      pageConfiguration.isStarted = true;
      pageConfiguration.isEnableT = true;

      // Save in memory curent configuration
      localStorage.setItem('search-selections', JSON.stringify({
        searchText: searchText,
        filters: filters,
        order: order,
        fullResponse: data,
        mainFultersSource:[],
        pageConfiguration: pageConfiguration,
      }));
    });
  }

  const productClick = (book, index)=>{
    let shopify_id = book.shopify_id;
    let searchTextFn = getParamsUrl('q') ? getParamsUrl('q') : pageConfiguration.searchText;
    fetch('https://search.ellibrero.com/hit?q='+ searchTextFn +'&id='+ shopify_id, {
      method: 'GET',
      cache: "no-store"
    })
    .then(response => response.json())
    .then((data)=>{});
    
    // SET POSITION
    let currentMemory = getMemory();
    currentMemory['pageConfiguration'].lastTop = pageConfiguration.lastTop;
    currentMemory = JSON.stringify(currentMemory);
    localStorage.setItem('search-selections', currentMemory);

    let compare_price = parseInt(book.compare_price);
    let price = parseInt(book.price);
    let discount = (compare_price == 0) ? 0 : price - compare_price;

    // Save track
    sendEvent('select_item', {
          item_list_id:pageConfiguration.currentPage,
          item_list_name:'search',
          ecommerce: {
            items: [{
              item_id: book.isbn,
              item_name: book.title,
              affiliation: book.affiliation,
              // coupon:'-',
              currency: book.currency,
              creative_name:'',
              creative_slot:'',
              discount: Math.abs(discount),
              index: index,
              item_brand: book.brand,
              item_category: book.category,
              item_category2:'',
              item_category3:'',
              item_category4:'',
              item_category5:'',
              item_list_id:pageConfiguration.currentPage,
              item_list_name:'search',
              item_variant:'',
              location_id:'',
              price:book.price,
              promotion_id:'',
              promotion_name:'',
              quantity:'1'
            }]
          }
    });
  }

  const shortText = (text, length)=>{
    if(text.length < length){
      return text;
    }

    return text.substring(0, length)+'...';
  }

  const clearText = (text)=>{
    return text.replace(/[^a-zA-Z0-9áéíóúñ\s]/g, ' ');
  }

  const priceBook = (price)=>{
    return (price.indexOf('.') > 0) ? price : price+'.00';
  }

  const AddToCartButtonFromListResult = ({merchandise}) => {
    const {cartCreate, linesAdd, status} = useCart();

    const handleAddToCart = async (merchandise) => {
      setCurrentAdd(merchandise.id);

      getSanityData('/api/sanity/product-information', 'productId='+merchandise.slug)
      .then((response)=>{
        GLOBAL_VARS.CART.lastProductSelected = response.store.variants[0].store.gid;
        
        setTimeout(() => {
          localStorage.setItem('isCartUpdateKey', Math.random(0, 1));
          setCurrentAdd(null);
        }, 2000);
        
        const checkCartID = localStorage.getItem('shopifyCartId');

        if (!checkCartID) {
          cartCreate({
            lines: [
              {
                merchandiseId: response.store.variants[0].store.gid,
                quantity: 1,
              },
            ],
          });
        } else {
          const variantsId = response.store.variants[0].store.gid;
          linesAdd([{merchandiseId: variantsId, quantity: 1}]);
        }

        try{
          sendEvent('add_to_cart', {
            event: 'add_to_cart', //Static data
            currency: 'MXN', //Dynamic data
            value: response.store.priceRange.maxVariantPrice, //Dynamic data
            items: '', //Dynamic data
            item_id: response.store.id, //Dynamic data
            item_name: response.store.title, //Dynamic data
            affiliation: response.store.vendor, //Dynamic data
            coupon: '', //Dynamic data
            discount: '', //Dynamic data
            index: '', //Dynamic data
            item_brand: response.store.vendor, //Dynamic data
            item_category:
              response.tags && response.tags[0].title
                ? response.tags[0].title
                : null, //Dynamic data
            item_category2:
              response.tags[1] && response.tags[1].title
                ? response.tags[1].title
                : null, //Dynamic data
            item_category3:
              response.tags[2] && response.tags[2].title
                ? response.tags[2].title
                : null, //Dynamic data
            item_category4:
              response.tags[3] && response.tags[3].title
                ? response.tags[3].title
                : null, //Dynamic data
            item_list_id: '', //Dynamic data
            item_list_name: '', //Dynamic data
            item_variant: '', //Dynamic data
            location_id: response.store.id, //Dynamic data
            price: response.store.priceRange.maxVariantPrice, //Dynamic data
            quantity: '1', //Dynamic data
            buy_now: 'FALSE', //Dynamic data
            item_tag: '', //Dynamic data
            item_tag2: '', //Dynamic data
            item_tag3: '', //Dynamic data
            item_tag4: '', //Dynamic data
          });
        }catch(e){}
      })
    };

    return (
      <>
        {(currentAdd === merchandise.id) ? ( <SpinnerIcon /> ) : (
          <button
            className="btn-secondary btn-agregar "
            onClick={() => handleAddToCart(merchandise)}
          >
            <div className="relative p-1 flex justify-center align-center items-center gap-1">
              Agregar <div className="icon-agregar-sprite"></div>
            </div>
          </button>
        )}
      </>
    );
  };

  const handleonCreateComplete = async () => {
    setTimeout(() => {
      openCart();
    }, 2000);
  };

  const handleOnAdd = async () => {
    setTimeout(() => {
      openCart();
    }, 2000);
  };

  const discount = (product)=>{
    if(parseInt(product.compare_price)){
      let diference = (product.compare_price - product.price);
      return roundDownToNearestTen(Math.round((diference / product.compare_price) * 100));
    }
  }

  const showData = (book)=>{
    if(book.compare_price >  0 && (book.price < book.compare_price)){
      return true;
    }

    return false;
  }

  return (
    <CartProvider onCreate={handleonCreateComplete} onLineAdd={handleOnAdd}>
      <div className="product-list product-general-list" id="search-results">
        <div className="md:grid md:grid-cols-4 2xl:grid-cols-6 3xl:grid-cols-7 md:gap-5 xs:flex items-start xs:flex-wrap grid-products">
            {showResultList && productList.map((book, index)=>(
              <div className="product__card xs:w-1/2 xs:flex  xs:flex-row md:flex with-btn" key={index}>
                {discount(book) >= 50 && ( 
                    <div className='tag-discount tag-carroucel'>
                      <span>- {discount(book)}%</span>
                    </div>
                )}
                <div className="h-full flex flex-col" >
                  {book.ebook !== 0 && ( <div class="badge-ebook bg-purple-120">eBook</div> )}
                  <Link
                      to={`/producto/`+book.slug}
                      key={index}
                      className="product__card_image_wrapper relative md:h-52 w-full flex items-center"
                      onClick={()=>{productClick(book, index)}}
                    >
                      <div className="h-full w-full block">
                            <Image
                              src={book?.image ? book.image : BookNotFoundImage}
                              height={160}
                              width={140}
                              className="mx-auto my-auto product__card_image"
                              alt={"product image"}
                            />
                      </div>
                  </Link>
                  <div className="product__card_content_wrapper h-full">
                    <div className="card_content_wrapper">
                      <h3 className="product-title line-clamp">
                        {book.title}
                      </h3>
                        <p className="text-xs autor-title-container">
                          <b className='autor-title'>Autor</b>: 
                          <span className='autor-name'>
                            <Link
                              to={`/search?q=`+clearText(book.author)}
                              reloadDocument="true"
                            >  
                                {shortText(book.author, 20)}
                            </Link>
                          </span>
                        </p>
                    </div>
                    <div className="h-full flex justify-end flex-col xs:p-0">
                      <div className="card_price_wrapper mb-0">
                          <span className="card_price text-red-40 font-bold">
                            MXN&nbsp; {priceBook(book.price)}
                          </span>
                          {showData(book) && (<>
                            <span class="sale-price mb-0 text-xs leading-none text-purple-40 line-through">
                              ${priceBook(book.compare_price)}
                            </span>
                          </>)}
                      </div>
                    </div>
                    <div className='add-button-cart'>
                      <AddToCartButtonFromListResult merchandise={book} />
                    </div>
                  </div>
                </div>
              </div>
            ))}
        </div>
        {!productList.length && (
          <div id='not-found-results'>
              {isLoading && ( <SpinnerIcon /> )}
              {!isLoading && ( 
                  <div className='containet-not-found'>
                    <h2>¡Ups! No hay resultados</h2>
                    <div className="content-info">
                      Parece que no hay productos que coincidan con tu búsqueda: <br />
                      <b>“{textUserSearch}”</b><br />
                      Por favor, prueba con otras palabras.
                    </div>
                  </div>
               )}
          </div>
        )}
      </div>
    </CartProvider>
  );
}
